import {
  SearchForCityInfo,
  CityInfo,
} from '@cbinsights/cbientityservice/cbientityservice';
import { UseQueryResult, useQuery } from 'react-query';
import { searchForCity } from '../apis/SearchForCity';
import { EntityServicesKeys } from './UseSearchForEntity';

export const useSearchForCity = (
  request: Partial<SearchForCityInfo>,
  enabled: boolean
): UseQueryResult<CityInfo[], Error> =>
  useQuery<
    CityInfo[],
    Error,
    CityInfo[],
    [EntityServicesKeys, Partial<SearchForCityInfo>]
  >(['SearchForCity', request], () => searchForCity(request), {
    notifyOnChangeProps: ['data', 'isFetching', 'isFetchedAfterMount'],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled,
  });
